'use strict';

/**
 * Pict-Provider-CallDeskAPI
 * -------------------------
 * Browser-side client for turning a logged Call into an Issue or a Feedback record. Call CRUD itself
 * (create the call, list a customer's calls) goes through the generic EntityAPI; these two routes
 * carry the call's customer + contact context onto the spawned record, server-side.
 */

const libPictProvider = require('pict').ServiceProviderBase;
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'CallDeskAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/'
};

class PictProviderCallDeskAPI extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DefaultProviderConfiguration, pOptions || {}), pServiceHash);
		this.routePrefix = this.options.RoutePrefix;
	}

	_url(pPath) { let tmpPrefix = this.routePrefix; if (tmpPrefix.charAt(tmpPrefix.length - 1) !== '/') { tmpPrefix += '/'; } return tmpPrefix + pPath.replace(/^\//, ''); }
	_post(pPath, pBody) { return libFrameworkClient.postJSON(this.fable, this._url(pPath), pBody || {}).catch(() => null); }

	spawnIssue(pCallID, pDraft) { return this._post('Call/' + encodeURIComponent(pCallID) + '/SpawnIssue', pDraft || {}); }
	spawnFeedback(pCallID, pDraft) { return this._post('Call/' + encodeURIComponent(pCallID) + '/SpawnFeedback', pDraft || {}); }
}

module.exports = PictProviderCallDeskAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;
